import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class ShortcutService {
  private readonly _focusSearchBar$ = new Subject<void>()

  /**
   * Strg+K, auf dem Mac auch ⌘K (dort der gewohnte Griff); ein großes K bei Feststelltaste zählt mit.
   * Muss am `keydown` haengen: Firefox oeffnet bei ⌘K/Strg+K schon dort seine Websuche, und auf dem Mac
   * feuert eine Taste bei gehaltenem ⌘ gar kein `keyup` (bis 2026-10-26 lag es dort, ⌘K tat in Firefox
   * deshalb das Falsche).
   */
  receiveEvent(event: KeyboardEvent) {
    if ((event.ctrlKey || event.metaKey) && (event.key === 'k' || event.key === 'K')) {
      event.preventDefault()
      this._focusSearchBar$.next()
    }
  }

  get focusSearchBar$() {
    return this._focusSearchBar$.asObservable()
  }
}
